/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class ConsiderationPeriodEnum.
* @enum {}
* @readonly
*/
export default class ConsiderationPeriodEnum {
    
        /**
         * value: "一ヶ月以内"
         * @const
         */
        "一ヶ月以内" = "一ヶ月以内";

    
        /**
         * value: "半年以内"
         * @const
         */
        "半年以内" = "半年以内";

    
        /**
         * value: "一年以内"
         * @const
         */
        "一年以内" = "一年以内";

    
        /**
         * value: "それ以上"
         * @const
         */
        "それ以上" = "それ以上";

    

    /**
    * Returns a <code>ConsiderationPeriodEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ConsiderationPeriodEnum} The enum <code>ConsiderationPeriodEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

